// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drain-timeout[data-v-3cfe9a24]{margin-top:5px;margin-left:18px;width:calc(100% - 18px)}", ""]);
// Exports
module.exports = exports;
